export default "__VITE_ASSET__mmHlrrNz__"